export default async function sleep(delay = 1000): Promise<void> {
  return new Promise((r) => setTimeout(r, delay));
}
